import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import downArrow from "../../../../assets/svg/downarrow.svg";
import upArrow from "../../../../assets/svg/uparrow.svg";
import download from "../../../../assets/svg/download.svg";
import archive from "../../../../assets/svg/archive.svg";
import obsolete from "../../../../assets/svg/obsolete.svg";
import revise from "../../../../assets/svg/revise.svg";
import info from "../../../../assets/svg/info.svg";
import document from "../../../../assets/svg/documentActive.svg";
import Moment from "moment";
import FileSaver from "file-saver";
import "./folder.css";
import { useDispatch, useSelector } from "react-redux";
import { rightBarOpen, setCategoryData } from "../../../../redux/action/Action";
import Breadcrumbs from "../BreadGrumbs";
import { useLocation } from "react-router-dom";
import axios from "axios";
import {
  ARCHIVE,
  OBSOLETE,
  REVISE,
  PROPERTIES,
  UNOBSOLETE,
} from "../../../../helpers/Rightbar_action";
import {
  POST_DOCUMENTS,
  POST_CATEGORIES,
  POST_GET_FILES,
  POST_DOWNLOAD_MULTIPLE_FILE,
} from "../../../../helpers/endpointService";
import role from "../../../../helpers/role";
import {} from "../../../../redux/action/Action";
import { ToastContainer, toast } from "react-toastify";
import { PulseLoader } from "react-spinners";
import Pagination from "../Pagination";
import PaginationComponent from "../Pagination";
import { logoutFunction } from "../../../custom/commonFunction";
import PasswordLoginModal from "../../../custom/commonPasswordLogin";

var sortName = "documentNo";
var sortOrder = "asc";

export default function Folder2() {
  const userId = localStorage.getItem("UserId");
  const { category2Id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  //   const currentFolder = useSelector(state => state.currentFolder)
  const userRole = localStorage.getItem("Role");
  const nav = useNavigate();
  const [fileSelected, setFileSelected] = useState("");
  // const [isCheckAll, setIsCheckAll] = useState(false);
  const [documents, setdocuments] = useState();
  const [isLoader, setLoader] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  /* const [sortName, setSortName] = useState('publishedDate');
  const [sortOrder, setSortOrder] = useState("asc"); */
  const [fileStatus, setFileStatus] = useState();
  const [isMobile, setisMobile] = useState(false);
  const [iswebMobile, setWebMobile] = useState(false);
  const [pageNewCount, setpageNewCount] = useState(false);

  const [paginationperPage, setpaginationperPage] = useState(20);
  const [paginationpageCount, setpaginationPageCount] = useState(1);
  const [openDocument, setOpenDocument] = useState({});

  let archiveTrigger = useSelector(
    (state) => state.documentReducer.archiveTrigger
  );

  ///////////////////// Fetch documents ////////////////////

  useEffect(() => {
    /* fetchDocument(); */
    const intervals = setInterval(() => {
      resize();
    }, 10);
    return () => clearInterval(intervals);
  }, []);

  useEffect(() => {
    sortName = "documentNo";
    sortOrder = "asc";
    fetchDocument();
  }, [archiveTrigger]);

  const resize = () => {
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }

    if (window.innerWidth < 400) {
      setWebMobile(true);
    } else {
      setWebMobile(false);
    }
  };

  const fetchDocument = async (currentPage, perPage) => {
    setFileSelected("");
    let order = sortOrder === "asc" ? true : false;
    setLoader(true);
    setpaginationperPage(perPage || 20);
    setpaginationPageCount(currentPage || 1);
    let apiUrl = `${POST_DOCUMENTS}?categoryId=${category2Id}&userId=${userId}&sortBy=${sortName}&isSortAscending=${order}`;
    const pageDetails = {
      pageNumber: currentPage || 1,
      pageSize: perPage || 20,
    };

    axios({
      method: "POST",
      url: apiUrl,
      data: pageDetails,
    })
      .then((response) => {
        setLoader(false);
        if (response?.status === 200) {
          setdocuments(response.data);
          setPageCount(response.data.totalCount);
        }
      })
      .catch((err) => {
        setLoader(false);
        logoutFunction(err?.response?.status);
      });
  };

  /////////////////////////////////// Checkbox handling ///////////////////////////////////
  // const handleSelectAll= e => {

  //   setIsCheckAll(!isCheckAll);
  //   setFileSelected(documents?.values.map(list => list.id));

  //   if (isCheckAll) {
  //     setFileSelected([]);
  //   }

  // }

  const handleClick = (id) => {
    nav(`${id}`);
  };

  const getDocumentDetails = (item) => {
    setOpenDocument(item);
  };

  const passwordValidationSuccess = () => {
    nav(`${openDocument.id}`);
  };

  const passwordValidationFailed = () => {
    // nav(`${id}`);
  };

  const handleChangeChecked = (id) => {
    if (fileSelected === id) {
      setFileSelected("");
    } else setFileSelected(id);
  };

  const openRightBar = (type) => {
    dispatch(rightBarOpen(type, fileSelected));
  };

  /////////////////////////////////// dowload files ///////////////////////////////////
  const downloadDocument = () => {
    if (fileSelected !== "") {
      setLoader(true);
      const fetchFilesFromDoc = async () => {
        let apiUrl = `${POST_GET_FILES}?docId=${fileSelected}&userId=${userId}`;

        const pageDetails = {
          pageNumber: 1,
          pageSize: 20,
        };

        axios({
          method: "POST",
          url: apiUrl,
          data: pageDetails,
        })
          .then((response) => {
            if (response?.status === 200) {
              proceedToDownload(response.data);
            }
          })
          .catch((err) => {
            setLoader(false);
            logoutFunction(err?.response?.status);
          });
      };
      fetchFilesFromDoc();

      const proceedToDownload = async (data) => {
        const extractedIds = [];
        let leftOutCount = 0;
        if (data?.values?.length > 0) {
          data?.values?.forEach((obj) => {
            if (obj.fileType !== "url") {
              extractedIds.push(obj.id);
            } else {
              leftOutCount++;
            }
          });

          let apiUrl = `${POST_DOWNLOAD_MULTIPLE_FILE}`;

          axios({
            method: "POST",
            url: apiUrl,
            data: extractedIds,
            responseType: "blob",
          })
            .then((response) => {
              setLoader(false);
              if (response?.status === 200) {
                let blob = "";
                blob = new Blob([response.data], { type: response.data.type });
                FileSaver.saveAs(blob);
                {
                  leftOutCount > 0 &&
                    toast.warn(
                      `${leftOutCount} file format${
                        leftOutCount > 1 ? "s" : ""
                      } not supported to dowload`,
                      {
                        position: toast.POSITION.TOP_RIGHT,
                        color: "#fff",
                      }
                    );
                }
              }
            })
            .catch((err) => {
              setLoader(false);
              logoutFunction(err?.response?.status);
            });
        } else {
          setLoader(false);
          toast.warn(`No files to download`, {
            position: toast.POSITION.TOP_RIGHT,
            color: "#fff",
          });
        }
      };
    }
  };

  ////////////////////////// Sort table ////////////////////////////////
  const sortTable = (name) => {
    if (documents?.values?.length !== 0) {
      let order = sortOrder;
      if (sortName === name) {
        sortName = name;
        if (sortOrder === "asc") {
          sortOrder = "desc";
        } else {
          sortOrder = "asc";
        }
      } else {
        sortName = name;
        sortOrder = "asc";
      }
      sortbyFormat();
    }
  };

  const sortbyFormat = (sortName, sortOrder) => {
    setpageNewCount(!pageNewCount);
    fetchDocument(1, paginationperPage);
  };

  /*  const sortTable = name => {
  const sortedData = [...documents?.values];

  let order = sortOrder;

  if(sortName === name) {

    if(sortOrder === "dec"){ 
        order = "asc"
      setSortOrder(order)
    }
    else { 
        order = "dec"
      setSortOrder(order)
    }
  }

  setSortName(name)
  
  sortedData.sort((a, b) => {

    const valueA = a[name];
    const valueB = b[name];

    if (name === "assignedDate" || name === "publishedDate"||name==="reviewDate"||name==="requestedDate")  {
      const dateA = new Date(a[name]); 
      const dateB = new Date(b[name]);
  
      if (order === 'asc') {
        return dateA.getTime() - dateB.getTime();
      } else {
        return dateB.getTime() - dateA.getTime();
      }
    }
      else if (typeof valueA === 'number' && typeof valueB === 'number') {
      // Numeric sorting
      if (order === 'asc') {
        return valueA - valueB;
      } else {
        return valueB - valueA;
     }

    } else {
      
          if (order === 'asc') {
            return (valueA ??" ").localeCompare(valueB? valueB:"");
          } else {
            return (valueB ??" ").localeCompare(valueA? valueA:"");
          }
      }
  });
    setdocuments({ ...documents, values: sortedData }); 
};  */

  const getStatusById = (id) => {
    if (id) {
      const item = documents?.values.find((obj) => obj.id === parseInt(id));
      return item ? item.documentStatus : "Not Found";
    }
  };

  useEffect(() => {
    setFileStatus(getStatusById(fileSelected));
  }, [fileSelected]);

  return (
    <>
      <ToastContainer
        limit={1}
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {isLoader && (
        <div className="spinner_overlay">
          <div className="loader">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        </div>
      )}

      <div className="titleContainer">
        <div className="title">
          <img src={document} />
          <span>Documents</span>
        </div>
        <div
          className={
            fileSelected !== ""
              ? "functionButtons"
              : "functionButtons disableddocuments"
          }
        >
          <div onClick={downloadDocument}>
            <img src={download} alt="" />
            <span>Download</span>
          </div>

          {userRole === role.ADMIN &&
          (fileStatus?.toLowerCase() === "published" ||
            fileStatus?.toLowerCase() === "republished") ? (
            <>
              <div onClick={() => openRightBar(REVISE)}>
                <img src={revise} alt="" />
                <span>Renew</span>
              </div>
              <div onClick={() => openRightBar(ARCHIVE)}>
                <img src={archive} alt="" />
                <span>Archive</span>
              </div>
              <div onClick={() => openRightBar(OBSOLETE)}>
                <img src={obsolete} alt="" />
                <span>Obsolete</span>
              </div>
            </>
          ) : userRole === role.ADMIN &&
            fileStatus?.toLowerCase() === "obsolete" ? (
            <>
              <div onClick={() => openRightBar(UNOBSOLETE)}>
                <img src={obsolete} alt="" />
                <span>Unobsolete</span>
              </div>
            </>
          ) : (
            <></>
          )}
          <div onClick={() => openRightBar(PROPERTIES)}>
            <img src={info} alt="" />
            <span>Properties</span>
          </div>
        </div>

        <Breadcrumbs location={location} />
      </div>

      {documents?.values?.length > 0 ? (
        <div
          className={` table-responsive  table-fixed-header Document-responsive-height`}
          //table-fixed-header fileList2
          style={{
            marginTop: isMobile
              ? fileSelected !== ""
                ? "160px"
                : "113px"
              : fileSelected !== ""
              ? "174px"
              : "122px",
    
            marginTop:iswebMobile
              ? fileSelected !==""
                ?"180px"
                :"120px"  
              : fileSelected !== ""
              ? "174px"
              : "122px",
          }}
        >
          {/* <div
          className={`${
            isMobile ? " table-mobile-height" : " table-height"
          }  table-responsive position-relative`}
          //table-fixed-header fileList2
          style={{
            marginTop: isMobile
              ? fileSelected !== ""
                ? "160px"
                : "113px"
              : fileSelected !== ""
              ? "174px"
              : "122px",
          }}
        ></div> */}
          <table className="fileListTable2" style={{ width: "100%" }}>
            <thead className="thead-sticky thead-color">
              <tr>
                <td className="wid-7"></td>
                <td
                  className="cursor-pointer"
                  onClick={() =>
                    sortTable("documentNo")
                  } /* style={{display :'flex'}} */
                >
                  <span>Document no.</span>
                  {sortName === "documentNo" && (
                    <img
                      src={sortOrder === "asc" ? upArrow : downArrow}
                      alt=""
                    />
                  )}
                </td>
                <td
                  className="cursor-pointer"
                  onClick={() => sortTable("documentName")}
                >
                  <span>Document name</span>
                  {sortName === "documentName" && (
                    <img
                      src={sortOrder === "asc" ? upArrow : downArrow}
                      alt=""
                    />
                  )}
                </td>
                <td
                  className="cursor-pointer"
                  onClick={() => sortTable("authorName")}
                >
                  <span>Author</span>
                  {sortName === "authorName" && (
                    <img
                      src={sortOrder === "asc" ? upArrow : downArrow}
                      alt=""
                    />
                  )}
                </td>
                {userRole === role.ADMIN && (
                  <td
                    className="cursor-pointer"
                    onClick={() => sortTable("documentStatus")}
                  >
                    <span>Status</span>
                    {sortName === "documentStatus" && (
                      <img
                        src={sortOrder === "asc" ? upArrow : downArrow}
                        alt=""
                      />
                    )}
                  </td>
                )}
                <td
                  className="cursor-pointer"
                  onClick={() => sortTable("publishedDate")}
                >
                  <span>Published date/time</span>
                  {sortName === "publishedDate" && (
                    <img
                      src={sortOrder === "asc" ? upArrow : downArrow}
                      alt=""
                    />
                  )}
                </td>
              </tr>
            </thead>

            <tbody>
              {documents?.values?.map((list, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        name="request"
                        value={list.documentNo}
                        checked={fileSelected === list.id ? true : false}
                        onChange={() => handleChangeChecked(list.id)}
                      />
                    </td>
                    <td>
                      {/* style={{ display: "flex" }} */}
                      <span
                        onClick={
                          list.isPasswordProtected == false
                            ? () => handleClick(list.id)
                            : () => getDocumentDetails(list)
                        }
                        // onClick={() => getDocumentDetails(list)}
                        className="fileName"
                        //className="tableoverflowNo"
                        style={{ color: "blue" }}
                        title={list.documentNo}
                        data-bs-toggle={
                          list.isPasswordProtected == true && "modal"
                        }
                        data-bs-target={
                          list.isPasswordProtected == true &&
                          "#passwordLoginModal"
                        }
                      >
                        {list.documentNo}
                      </span>
                    </td>
                    <td>
                      <span
                        className="tableoverflowNo"
                        title={list.documentName}
                      >
                        {list.documentName}
                      </span>
                    </td>
                    <td>
                      <span className="tableoverflow1" title={list.authorName}>
                        {list.authorName}
                      </span>
                    </td>
                    {userRole === role.ADMIN && (
                      <td>
                        <span
                          style={{
                            color:
                              list?.documentStatus?.toLowerCase() ===
                                "published" ||
                              list?.documentStatus?.toLowerCase() ===
                                "republished"
                                ? "#21A366"
                                : list?.documentStatus?.toLowerCase() ===
                                  "obsolete"
                                ? "#D12232"
                                : "#FF9000",
                            fontWeight: "600",
                          }}
                          className="tableoverflow1"
                          title={list.documentStatus}
                        >
                          {list.documentStatus}
                        </span>
                      </td>
                    )}
                    <td>
                      <span className="tableoverflowDate">
                        {list.publishedDate
                          ? Moment(
                              new Date(Date.parse(list.publishedDate))
                            ).format("DD-MMM-YYYY h:mm A")
                          : ""}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <>
          <span className="empty">{documents && "Folder is empty"}</span>
        </>
      )}
      <PasswordLoginModal
        item={openDocument}
        passwordValidated={() => passwordValidationSuccess()}
        passwordFailed={() => passwordValidationFailed()}
        moduleName="document"
      />
      {documents?.values?.length > 0 && (
        <PaginationComponent
          fetchPagination={fetchDocument}
          pageCount={pageCount}
          reset={pageNewCount}
        />
      )}
    </>
  );
}
